<template>
<div class="chapter">
<div class="inner_page">
<h1 class="title">Eight Faces at Three</h1>
<p class="title1">A John J. Malone Mystery</p>
<p class="title2">Craig Rice</p>
<div class="imagetit"><img alt="images" src="images/tit.jpg"/></div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Title.vue?2728673a